import React, { useState } from 'react'
import { getStaticImage } from 'utils/statics'
import './styles.scss'
import { lang } from 'utils/helpers'
import { saveAs } from 'file-saver'
import { convertBytes } from 'utils/FileUtils'

const CardFile = ({ file }) => {
  const [viewDownload, setViewDownload] = useState(false)

  const handleOpenLink = (url) => {
    window.open(url, '_blank')
  }

  const handleDownloadFile = (url, fileName) => {
    saveAs(url, fileName)
  }

  return (
    <div
      key={file.fileId}
      className='inchat-files-card'
      title={file.filename}
      onMouseEnter={() => setViewDownload(true)}
      onMouseLeave={() => setViewDownload(false)}
    >
      <div
        className='inchat-files-card__icon-text'
        onClick={() => handleOpenLink(file.urlLong || '')}
      >
        <img
          src={`${getStaticImage(`/icons/orange-brand/icon-doc.svg`)}`}
          alt={'icon'}
          onError={event => {
            event.target.className = 'not-channel-icon'
            event.onerror = null
          }}
        />
        <label className='text-ellipsis'>{file.filename}</label>
      </div>
      {viewDownload
        ? <button
          className='inchat-files-card__button'
          onClick={() => handleDownloadFile(file.urlLong, file.filename)}
        >
          <img
            src={`${getStaticImage(`/icons/orange-brand/icon-download-grey.svg`)}`}
            alt={lang('dashboard_download')}
            onError={event => {
              event.target.className = 'not-channel-icon'
              event.onerror = null
            }}
          />
          {lang('dashboard_download')}</button>
        : <label className='inchat-files-card__size'>{convertBytes(file.size)}</label>
      }
    </div>
  )
}

export default CardFile